import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { NetworkConstants } from 'na-lib';
import { deleteDoc, doc, getFirestore } from '@angular/fire/firestore';
import { FirestoreService } from './firestore.service';

@Injectable({
  providedIn: 'root'
})
export class FinishedTasksService {
  db = this.firestore.db//getFirestore()
 
  constructor(private settingsService: SettingsService,
    private firestore:FirestoreService) { }

    deleteFinishedTasks(finishedId):Promise<void>{
      return new Promise(async (resolve, reject) => {
        try {

          const docRef = doc(this.db, NetworkConstants.COLLECTION_CONTEXTS, this.settingsService.contextId$,NetworkConstants.COLLECTION_WORK_TASKS, finishedId)
          const d  = await deleteDoc( docRef)
          resolve(d)
        } catch (error) {
          reject(error)  
          console.log(error)      
        } 
      })
    }
}